import React, { Component } from 'react';
import $j from 'jquery';
import { message } from 'antd';
import classNames from 'classnames';
import listensToClickOutside from 'react-onclickoutside';
import Icon from '../../helper/Icon';

import { uploadToS3 } from '../../helper/fileUpload';
import { resizeImage } from '../helper/GetImagePlaceholder';

class MediaUpload extends Component {
  state = {
    uploading: false
  };

  toggleMenu = show => {
    const { src } = this.props;
    const srcAvailable = src && src !== '' && src.length > 0;
    if (!srcAvailable) {
      return;
    }
    if (show)
      return $j(`.MediaUploadContainer .menu#${this.props.uniqueId}`).addClass('menu--active');
    return $j(`.MediaUploadContainer .menu#${this.props.uniqueId}`).removeClass('menu--active');
  };

  handleClickOutside() {
    this.toggleMenu(false);
  }

  imageChangeCallback = s3Url => imagePlaceholder => {
    this.toggleMenu(false);
    const url = s3Url || '';
    const imagePlaceholderBase64 = typeof imagePlaceholder === 'string' ? imagePlaceholder : '';
    this.props.uploadDone && this.props.uploadDone(url, imagePlaceholderBase64);
  };

  uploadMedia = type => e => {
    e.persist();
    this.toggleMenu(false);
    const uploadFile = e.target.files[0];
    console.log(resizeImage(uploadFile, 10));
    if (uploadFile) {
      e.target.value = null;
      const fileSize = uploadFile.size / (1000 * 1000);
      const isGif = (uploadFile.type && uploadFile.type.includes('/gif')) || false;
      // console.log('fileSize', fileSize);
      // Allowed Gif file to be uploaded till size 100mb
      if (!isGif && fileSize > 10) {
        message.warning(
          'File size should not be larger then 10MB, provided file size is ' +
            fileSize.toFixed(2) +
            'MB...',
          4
        );
        // console.log('fileupload:: ', 'File size error');
        return false;
      }
      if (isGif && fileSize > 101) {
        message.warning(
          'Gif image size should not be larger then 100MB, provided image size is ' +
            fileSize.toFixed(2) +
            'MB...',
          4
        );
        // console.log('fileupload:: ', 'File size error');
        return false;
      }
      const fileName = `${this.props.uniqueId ||
        'qwerty'}_${new Date().getTime()}.${uploadFile.name.split('.').pop()}`;

      const s3Url = window.constants.s3LyearnBucketUrl + 'lessonBlockImages/' + fileName;

      const uploadPromise = uploadToS3(s3Url, uploadFile, uploadFile.type);
      this.setState({
        uploading: true
      });
      // debugger;
      uploadPromise
        .then(data => {
          this.setState({
            uploading: false
          });
          // console.log(resizeImage(uploadFile, 10));
          resizeImage(uploadFile, 10, this.imageChangeCallback(s3Url));
        })
        .catch(reason => {
          this.setState({
            uploading: false,
            uploadError: true
          });
          message.error('Something went wrong, Please try again or contact support...');
        });
    } else {
      return false;
    }
  };

  clickChildLabel = e => {
    $j(e.target)
      .find('label')
      .trigger('click');
  };

  renderImageOrStatus = src => {
    if (this.state.uploading) {
      return (
        <div className="upload">
          <strong className="upload__text">Uploading...</strong>
          {/* <button className="upload__action">Cancel</button> */}
        </div>
      );
    }
    if (src.length > 0) {
      return [
        <div key={1} className="item-media__thumb-container">
          <figure
            className="item-media__thumb"
            style={{ backgroundImage: 'url(' + src + ')', backgroundSize: '100%' }}
          />
        </div>,
        <div key={2} className="item-media__name">
          <div className="item-media__text" />
        </div>
      ];
    }
    if (!src || src === '') {
      return (
        <div className="item-media__name">
          <div className="item-media__text-placeholder">
            Upload an image or video file, or embed something from the web.
          </div>
        </div>
      );
    }
  };

  renderUploadableImage = () => (
    <span>
      <label htmlFor={`${this.props.uniqueId}s0.423029640158747123`} className="button">
        <Icon icon="photo" size="15px" />
      </label>
      <input
        ref="imageFileUploader"
        type="file"
        id={`${this.props.uniqueId}s0.423029640158747123`}
        accept="image/png, image/gif, image/jpeg, image/svg+xml, image/bmp, image/tiff"
        style={{ display: 'none' }}
        onChange={this.uploadMedia('IMAGE')}
      />
    </span>
  );

  renderMediaMenu = (src, srcAvailable) => {
    const buttonClass = classNames('menu__toggle', {
      'item-media__actions-link': srcAvailable,
      'item-media__icon item-media__icon-large': !srcAvailable
    });
    return (
      <div className="media-menu">
        <div className="menu" id={this.props.uniqueId}>
          {!this.state.uploading && (
            <button className={buttonClass} onClick={this.toggleMenu}>
              {!srcAvailable ? this.renderUploadableImage() : 'Edit'}
            </button>
          )}
          <div>
            <div className="menu__content menu__content--right menu__content">
              <div className="menu__listWrapper">
                <ul className="menu__list">
                  <li className="menu__item" onClick={this.clickChildLabel}>
                    <span>
                      <label
                        htmlFor={`${this.props.uniqueId}s0.423029640158747`}
                        className="button"
                      >
                        <span>
                          <span className="menu__icon">
                            <Icon
                              icon="file-upload-2"
                              size="15px"
                              viewBox="0 0 15 15"
                              fill="#313537"
                            />
                          </span>
                          {!srcAvailable ? 'Upload media' : 'Replace media'}
                        </span>
                      </label>
                      <input
                        ref="imageFileUploader"
                        type="file"
                        id={`${this.props.uniqueId}s0.423029640158747`}
                        accept="image/png, image/gif, image/jpeg, image/svg+xml, image/bmp, image/tiff"
                        style={{ display: 'none' }}
                        onChange={this.uploadMedia('IMAGE')}
                      />
                    </span>
                  </li>
                  {srcAvailable ? (
                    <li className="menu__item" onClick={this.imageChangeCallback('')}>
                      <span className="menu__icon">
                        <Icon icon="remove-2" size="15px" fill="#313537" viewBox="0 0 10 13" />
                      </span>
                      <span>Remove</span>
                    </li>
                  ) : null}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { src } = this.props;
    const srcAvailable = src && src !== '' && src.length > 0;
    return (
      <div className="MediaUploadContainer">
        <div className="block-edit-field-embed">
          <div className="item-media__row">
            {this.renderImageOrStatus(this.props.src)}
            {this.renderMediaMenu(this.props.src, srcAvailable)}
          </div>
        </div>
      </div>
    );
  }
}

export default listensToClickOutside(MediaUpload);
